import React, { useEffect, useState } from 'react'
import DashboardPagesTemplate from '../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import { ColumnRefund, RefundData } from '../../types/TablesTypes/Refund'
import showToast from '../../components/CustomToast/toastHelper'
import client from '../../api/client'
import StatusView from '../../components/StatusView/StatusView'
import { FaEllipsisH } from 'react-icons/fa'
import { numberWithCommas } from '../../utils/formatNumber'
import moment from 'moment'
import { useCurrency } from '../../contexts/CurrencyContext'
import CustomModal from '../../components/Modal/CustomModal'
import LogSingleRefund from './LogSingleRefund/LogSingleRefund'
import { Dropdown } from 'flowbite-react'
import RefundDetails from './RefundDetails/RefundDetails'
const Refunds = () => {
    const [filters, setFilters]= useState({
        fromDate:"",
        toDate:"",
        status:""
    })
    const [refunds, setRefunds] = useState<any>()
    const [tableRow, setTableRow]= useState<any[]>([])
    const {currency} = useCurrency()
    const [loading, setLoading] = useState<boolean>(false)
    const [openRefundModal, setOpenRefundModal] = useState<boolean>(false)
    const [isExport, setIsExport] = useState<boolean>(false)
    const [isExportReady, setIsExportReady] = useState<boolean>(false);
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false);
    const [openDetailsModal, setOpenDetailsModal]= useState<any>({
      value:false,
      data:null
    })
    const clickExport = async () => {
      setIsExport(true);
      setIsExportLoading(true)
      await fetchRefunds();
  
      if (refunds && refunds.items?.length > 0) {
        setIsExportReady(true);
      }
  
      setIsExportLoading(false);
    };

    useEffect(() => {
      const fetchData = async () => {
          await fetchRefunds();
      };
      fetchData();
  }, [filters]);

    const logRefunds = () =>{
      return null
    }

  const fetchRefunds = async () => {
      setLoading(true)
      try {
          const apiUrl = '/subsidiary/dashboard/refund/all';
          const params = new URLSearchParams(filters).toString();
          const response = await client.get(`${apiUrl}?${params}`);

          setRefunds(response.data.data);
          const message = response?.data?.message;

      } catch (err: any) {
          if (err?.response?.data?.message === 'Please login again') {
              sessionStorage.clear();
              window.location.href = '/';
          } else {
              const message = err?.response?.data?.message;
              console.error('error getting data', err);
              showToast(message, "error");
          }
      }
      finally{
        setLoading(false)
      }
  };

  const dataTransaction = () => {
		const tempArr: RefundData[] = [];
		refunds?.items
			?.slice(0)
			.reverse()
			.forEach((transaction: any, index: number) => {
				tempArr.push({
					amount: `NGN ${numberWithCommas(transaction?.refundAmount)}`,
					customerId: transaction?.customerId,
					transactionReference: transaction?.orderReference,
					date: moment(transaction?.dateCreated).format("DD-MMM-YYYY hh:mm:ss a"),
					originalTransactionDate:moment(transaction?.orderDateCreated).format("DD-MMM-YYYY hh:mm:ss a"),
          refundReceipt:transaction.providerReceipt,
          status: (
						<StatusView
							status={transaction?.refundStatus}
							green='Approved'
							red='Declined'
							orange='Processing'
						/>
					),
					action: (<Dropdown label={<FaEllipsisH/>} inline arrowIcon={false}>
              <Dropdown.Item onClick={()=>setOpenDetailsModal({value:true, data:transaction})}>View Details</Dropdown.Item>
            </Dropdown>) ,
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataTransaction());
	}, [refunds?.items]);

  
  return (
    <div>
      <DashboardPagesTemplate
        apiUrl=''
        show={openRefundModal}
        openModal={()=>setOpenRefundModal(true)}
        closeModal={()=>setOpenRefundModal(false)}
        children= {<LogSingleRefund close={()=>setOpenRefundModal(false)} onComplete={()=>fetchRefunds()}/>}
        dataToExport={refunds?.items}
        onFilterChange={setFilters} 
        data={tableRow ? tableRow : []}
        title='Refunds'
        headings={ColumnRefund}
        exportButtonExists={true}
        ctaButtonExists={true}
        buttonLabel='Log a refund'
        buttonIcon=''
        showSearch={false}
        loading={loading}
        filters={filters}
        dropdownItems={["All","Approved","Processing"]}
        datepickerExists={true}
        emptyMessage={`You do not have any refunds in ${currency}`}
        statusKey='status'
        clickExportButton={clickExport}
        exportButtonLoading={isExportLoading}
        exportButtonClicked={isExport}
        // onCtaButtonClick={logRefunds}
        
        
      />
      <CustomModal show={openDetailsModal.value} size='md' dismissible icon='' onClose={()=>setOpenDetailsModal({value:false, data:null})} children={
        <RefundDetails refund={openDetailsModal.data}/>
      }></CustomModal>
    </div>
  )
}

export default Refunds
